<template>
  <z-card width="100%" class="pa-0">
    <template #content>
      <v-list class="pa-0" dense nav>
        <z-scrollbar
          :style="{
            maxHeight: maxHeight,
            overflow: 'hidden',
          }"
        >
          <template v-if="history.length > 0">
            <v-subheader style="z-index: 1">
              {{ $t('your_search_history') }}
            </v-subheader>

            <z-exclusion-list
              :loading="loading"
              :items="history.slice(0, maxDisplayedItems)"
              @include="onInclude($event, 'history')"
              @exclude="onExclude($event, 'history')"
            ></z-exclusion-list>
          </template>

          <v-divider
            v-if="history.length > 0 && recommendations.length > 0"
            class="my-1 mx-2"
          ></v-divider>

          <template v-if="recommendations.length > 0">
            <v-subheader style="z-index: 2">
              {{ $t('recommendations') }}
            </v-subheader>

            <z-exclusion-list
              :loading="loading"
              :items="recommendations.slice(0, maxDisplayedItems)"
              @include="onInclude($event, 'recommendations')"
              @exclude="onExclude($event, 'recommendations')"
            ></z-exclusion-list>
          </template>
        </z-scrollbar>
      </v-list>
    </template>
  </z-card>
</template>

<script>
export default {
  props: {
    history: {
      type: Array,
      default: () => [],
    },

    recommendations: {
      type: Array,
      default: () => [],
    },

    maxHeight: {
      type: String,
      default: '300px',
    },

    loading: {
      type: Boolean,
      default: false,
    },

    maxDisplayedItems: {
      type: Number,
      default: 50,
    },
  },

  methods: {
    onInclude(item, list) {
      this.$emit('include', item, list)
    },

    onExclude(item, list) {
      this.$emit('exclude', item, list)
    },
  },

  i18n: {
    messages: {
      en: {
        your_search_history: 'Your search history',
        recommendations: 'Recommendations',
      },
      pt: {
        your_search_history: 'Seu histórico de pesquisa',
        recommendations: 'Recomendações',
      },

      es: {
        your_search_history: 'Tu historial de búsqueda',
        recommendations: 'Recomendaciones',
      },
      fr: {
        your_search_history: 'Votre historique de recherche',
        recommendations: 'Recommandations',
      },
      tr: {
        your_search_history: 'Arama geçmişiniz',
        recommendations: 'Tavsiyeler',
      },
    },
  },
}
</script>
